export const environment = {
  production: false,
  env: 'STAGE',
  serverUrl: 'https://api.allergan-eye-care.amd.staging.zsservices.com/',
  idmLogOutUrl: 'https://javelin.staging.zsservices.com/abbvie/IdentityManager-SSO/app/Web/logout.aspx',
  idmLogInUrl: 'https://javelin.staging.zsservices.com/abbvie/IdentityManager-SSO/app/Web/login.aspx'
};
